(function () {
  const INSURANCE_ID = /** @type {HTMLScriptElement|null} */ (
    document.currentScript || document.querySelector('script[src*="cart-insurance"]')
  )?.dataset?.insuranceId;

  const originalFetch = window.fetch.bind(window);

  /** @param {string} variantId */
  async function addInsurance(variantId) {
    await originalFetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 }),
    });
  }

  function triggerCartRefresh() {
    document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { data: {} } }));
  }

  /**
   * @param {BodyInit | null | undefined} rawBody
   * @param {string} insuranceId
   */
  function isInsuranceBody(rawBody, insuranceId) {
    if (typeof rawBody === 'string' && rawBody.length > 0) {
      try {
        const parsed = JSON.parse(rawBody);
        const ids = Array.isArray(parsed.items)
          ? parsed.items.map((/** @type {{ id: number }} */ i) => i.id)
          : [parsed.id];
        return ids.map(Number).includes(Number(insuranceId));
      } catch {}
    } else if (rawBody instanceof FormData) {
      return Number(rawBody.get('id')) === Number(insuranceId);
    }
    return false;
  }

  let isAutoAdding = false;

  /** @param {BodyInit | null | undefined} rawBody */
  async function maybeAutoAdd(rawBody) {
    if (isAutoAdding || !INSURANCE_ID) return;
    if (isInsuranceBody(rawBody, INSURANCE_ID)) return;

    isAutoAdding = true;
    try {
      const cart = await originalFetch('/cart.js').then((/** @type {Response} */ r) => r.json());
      if (!cart.items.some((/** @type {{ variant_id: number }} */ i) => i.variant_id === Number(INSURANCE_ID))) {
        await addInsurance(INSURANCE_ID);
        triggerCartRefresh();
      }
    } finally {
      isAutoAdding = false;
    }
  }

  // Intercept fetch — fire-and-forget, never blocks the add-to-cart response.
  window.fetch = async function (...args) {
    const [resource, options] = args;
    const response = await originalFetch(...args);

    const url = resource instanceof Request ? resource.url : String(resource);
    if (/\/cart\/add(\.js)?(\?|$)/.test(url) && response.ok) {
      maybeAutoAdd(options?.body).catch(() => {});
    }

    return response;
  };
})();
